import React from 'react'
import { ProgramStep } from './program-step'
import { AddOnsStep } from './addons-step'
import { AttendeesStep } from './attendees-step'
import { ReviewStep } from './review-step'
import { DateAndTimeStepSpecialtyProgram } from './date-time-specialty-program-step'
import { DateAndTimeStepAddOnProgram } from './date-time-add-on-program-step'
import { DesignSystem } from './design-system'

export const Steps = () => {
  return (
    <main className="main">
      <ProgramStep />
      <AddOnsStep />
      <DateAndTimeStepSpecialtyProgram />
      <DateAndTimeStepAddOnProgram />
      <AttendeesStep />
      <ReviewStep />
      <DesignSystem />
    </main>
  )
}
